export const DAG_NAMES = {
    INGEST_FILE_TO_GCS_BULK: 'ingest_file_to_gcs_bulk',
    INGEST_FILE_TO_GCS: 'ingest_file_to_gcs',
    MEASURES_PERIOD_RELEASE: 'measures_period_release_bq',
    GENERATE_MEASURES: 'measures_generate_measures_bq',
};